import * as queries from './queries'

export const envUtils = { ...queries }
